/** Shared text styling for the labels in the modifier sections. */
export const labelSx = {
    fontSize: 12,
    color: 'text.primary',
    userSelect: 'none',
} as const;

/** Styling for an inline "constraint enabled but inactive" warning. */
export const warningSx = {
    fontSize: 11,
    color: 'warning.main',
} as const;

/**
 * Styling for a muted "doesn't apply in this mode" note (e.g. Inside/Outside
 * shown while erasing). Dimmed rather than colored — it is informational, not a
 * problem the user needs to fix.
 */
export const mutedNoteSx = {
    fontSize: 11,
    color: 'text.muted',
} as const;
